import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import YesOrNoFields from 'brandComponents/YesOrNoFields';

import messages from './messages';

import styles from './NewsletterFlags.module.scss';

const NewsletterFlags = () => {
	const intl = useIntl();

	return (
		<div className={cn(styles['newsletter-flags'], 'newsletter-flags')}>
			<div className={styles['newsletter-flags__p']}>
				<span>{intl.formatMessage(messages.privacyPolicy)}</span>
			</div>
			<div className={styles['newsletter-flags__p']}>
				<span>{intl.formatMessage(messages.dataProfiling)}</span>
				<div className={styles['newsletter-flags__p--container']}>
					<YesOrNoFields
						name="authorizationDataCollection"
					/>
				</div>
			</div>
			<div className={styles['newsletter-flags__p']}>
				<span>{intl.formatMessage(messages.marketing)}</span>
				<div className={styles['newsletter-flags__p--container']}>
					<YesOrNoFields
						name="acceptsMarketing"
					/>
				</div>
			</div>
			<p className={styles['newsletter-flags__p']}>
				{intl.formatMessage(messages.disclaimer)}
			</p>
		</div>
	);
};

export default NewsletterFlags;
